'use client'
import { cn } from '@/lib/utils'
import Image from 'next/image'
import { text16px, text32px } from '@/app/utils'
import React from 'react'

export default function Map() {
  return (
    <div className={cn('bg-white text-foreground dark:text-background')}>
      <div className={cn('container py-12 flex space-x-10')}>
        <div className={cn('flex w-[25%] items-center justify-center')}>
          <Image
            alt={'intro-two'}
            src={'/home/china-map.svg'}
            width={420}
            height={310}
            className={cn('w-full object-cover transition-all')}
          />
        </div>
        <div
          className={cn(
            'flex flex-col w-[75%] items-start justify-center space-y-5'
          )}
        >
          <div className={cn(text32px, 'text-[#121127] font-bold')}>
            想获得我们的服务？请联系您所在的省级代理服务商
          </div>
          <div className={cn('flex flex-wrap gap-x-4 gap-y-2')}>
            <div className={cn(text16px, 'text-[#7A7A86]')}>北京</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>天津</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>河北</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>山西</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>黑龙江</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>吉林</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>辽宁</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>内蒙古自治区</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>上海</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>江苏</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>浙江</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>安徽</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>江西</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>山东</div>
            <div className={cn(text16px, 'text-[#444BD3] font-bold')}>福建</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>河南</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>湖北</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>湖南</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>广东</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>广西壮族自治区</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>海南</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>香港特别行政区</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>澳门特别行政区</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>重庆</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>四川</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>贵州</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>云南</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>西藏自治区</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>陕西</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>甘肃</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>青海</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>宁夏回族自治区</div>
            <div className={cn(text16px, 'text-[#7A7A86]')}>
              新疆维吾尔自治区
            </div>
          </div>
          <div
            className={cn('w-full flex flex-row items-center justify-between')}
          >
            <div className={cn(text16px, 'text-[#1D1D1D] font-bold')}>
              福建代理商电话：13000000000
            </div>
            <div className={cn(text16px, 'text-[#444BD3] font-bold')}>
              申请成为代理商
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
